import { IProductCarouselProps } from 'store/modules/product';

interface ProductImageProps {
  item: IProductCarouselProps;
  haveSelo: boolean;
}

export default function ProductImage({ item, haveSelo }: ProductImageProps) {
  return (
    <div className={`product-image${haveSelo ? ' have-selo' : ''}`}>
      {item.ultraPremio && (
        <img
          src="/images/card-icons/ultrapremio.png"
          alt="Ultrapremio"
          className="Selo UltraPremio"
        />
      )}

      <img loading="lazy" src={item.imagemUrl} alt={item.nome} />
    </div>
  );
}
